import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaypalSquare = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 37,
			height: 37,
			rx: 7.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 37,
			height: 37,
			rx: 7.5,
			stroke: "#ECECEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.9861 13.9107C26.0396 11.1282 23.7436 8.99219 20.5866 8.99219H14.0576C13.9054 8.99224 13.7582 9.0466 13.6425 9.14551C13.5268 9.24441 13.4503 9.38135 13.4266 9.53169L10.8101 25.8797C10.7984 25.9538 10.8029 26.0295 10.8232 26.1017C10.8436 26.1738 10.8794 26.2407 10.9281 26.2978C10.9768 26.3548 11.0373 26.4006 11.1054 26.432C11.1735 26.4634 11.2476 26.4797 11.3226 26.4797H15.1911L14.5861 30.2657C14.5744 30.3398 14.5789 30.4156 14.5993 30.4878C14.6197 30.56 14.6555 30.6269 14.7042 30.684C14.753 30.741 14.8136 30.7868 14.8817 30.8181C14.9499 30.8495 15.024 30.8657 15.0991 30.8657H18.2501C18.4026 30.8657 18.5381 30.8107 18.6536 30.7122C18.7691 30.6132 18.7881 30.4767 18.8116 30.3262L19.7366 24.8837C19.7601 24.7337 19.8366 24.5387 19.9526 24.4397C20.0681 24.3407 20.1691 24.2867 20.3211 24.2862H22.2501C25.3416 24.2862 27.9651 22.0892 28.4446 19.0327C28.7836 16.8627 27.8531 14.8892 25.9861 13.9107Z",
			fill: "#001C64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.028 20.4502L15.0645 26.5602L14.4595 30.3922C14.4478 30.4663 14.4523 30.542 14.4727 30.6143C14.4931 30.6865 14.5289 30.7534 14.5777 30.8104C14.6264 30.8675 14.687 30.9132 14.7551 30.9446C14.8233 30.976 14.8974 30.9922 14.9725 30.9922H18.3075C18.4596 30.992 18.6066 30.9376 18.7222 30.8387C18.8378 30.7398 18.9143 30.6029 18.938 30.4527L19.817 24.8827C19.8407 24.7325 19.9172 24.5956 20.0328 24.4968C20.1484 24.398 20.2954 24.3437 20.4475 24.3437H22.411C25.5025 24.3437 28.1255 22.0887 28.605 19.0322C28.945 16.8627 27.853 14.8892 25.986 13.9102C25.981 14.1412 25.961 14.3717 25.9255 14.6002C25.446 17.6562 22.8225 19.9117 19.731 19.9117H16.6585C16.5065 19.9117 16.3595 19.9659 16.2439 20.0646C16.1284 20.1633 16.0518 20.3 16.028 20.4502Z",
			fill: "#0070E0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.064 26.5581H11.184C11.109 26.5582 11.0348 26.542 10.9667 26.5106C10.8985 26.4792 10.838 26.4334 10.7893 26.3764C10.7406 26.3193 10.7048 26.2524 10.6845 26.1802C10.6641 26.108 10.6597 26.0322 10.6715 25.9581L13.2875 9.36712C13.3112 9.21684 13.3878 9.07995 13.5035 8.98113C13.6192 8.88231 13.7663 8.82805 13.9185 8.82813H20.587C23.7435 8.82813 26.0395 11.1256 25.986 13.9081C25.2005 13.4961 24.2775 13.2606 23.266 13.2606H17.7065C17.5545 13.2608 17.4075 13.3151 17.2919 13.4139C17.1763 13.5127 17.0998 13.6495 17.076 13.7996L16.0285 20.4481L15.064 26.5581Z",
			fill: "#003087"
		})
	]
});
const ForwardRef = forwardRef(SvgPaypalSquare);
export { ForwardRef as ReactComponent };
